import { Component, OnInit, OnDestroy, NgZone, ViewChild, ElementRef } from '@angular/core';

import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { SearchObjectService } from '../../shared/services/search-object.service';
import { SearchService } from './search.service';
import { NotificationContainerService } from 'src/app/shared/components/notification-container/notification-container.service';
import { LoadingScreenService } from 'src/app/shared/components/loading-screen/loading-screen.service';
import { SearchResultObject, SearchResultObjectService } from 'src/app/shared/services/search-result-object.service';
import { UserRulesService } from 'src/app/shared/services/user-rules.service';
//import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { FilterNavigationService } from 'src/app/shared/components/filter-navigation/filter-navigation.service';
import { SheetsService } from 'src/app/shared/components/sheets/sheets.service';
import { BannerCardService } from 'src/app/shared/components/banner-card/banner-card.service';
import { LaunchDarklyKey } from 'src/app/core/models/LaunchDarkly';
import { MapService } from 'src/app/shared/services/map.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, OnDestroy {
  LaunchDarklyKey = LaunchDarklyKey;
  isIOS; // prob move somewhere else later
  navigationSubscription;
  paramMap: any;
  isPCPSearch = false;
  isPharmacy = false;
  showAnywhereCare = false;
  showCardLoader = true;

  searchArray: any[] = [];

  page: string;
  showSearchToggle = false;
  showMapToggle = false;
  dataNoMap = false;

  showSearchDataDefault = 20;
  activeMarkerLetter = '';
  activeMarkerPos = 0;
  maxSearchData = 200;
  dualMaxSearch = 200;
  inputResultPage = 1;
  totalResultPage = 1;
  dataResultPage = 1;
  arrayResultPage = [];
  dataStartPos = 0;
  dataEndPos = 0;

  searchData: SearchResultObject[];
  searchDataLength = 0;
  searchErrorMsg = '';
  setMap = false;
  filtersSelected = false;
  clickedSearchCriteria = '';

  // upmc providers
  showPromoted = false;
  upmcData: SearchResultObject[];
  UPMC_DATA_MAX = 2;

  // digital providers
  showDigital = false;
  digitalData: SearchResultObject[];
  DIGITAL_DATA_MAX = 3;

  // level objects
  showLevels = false;
  showLevel1 = true;

  level1Providers: SearchResultObject[];
  level2Providers: SearchResultObject[];
  searchDataLength1 = 0;
  searchDataLength2 = 0;

  showSheets = false;
  sheetsSubscription;

  expandBanner = false;
  bannerCardSubscription;
  @ViewChild('resultDisplay', { static: true }) resultDisplay: ElementRef;
  @ViewChild('scrollTopSearch', { static: false }) scrollTopSearch: ElementRef;
  @ViewChild('stickyMap', { static: false }) stickyMap: ElementRef;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private loadingScreenService: LoadingScreenService,
    private searchObjectService: SearchObjectService,
    private searchService: SearchService,
    private searchResultObjectService: SearchResultObjectService,
    private filterNavigationService: FilterNavigationService,
    private notificationContainerService: NotificationContainerService,
    private mapService: MapService,
    private userRulesService: UserRulesService,
    //private GAService: GoogleAnalyticsService,
    private sheetsService: SheetsService,
    private bannerCardService: BannerCardService,
    private __zone: NgZone) {
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        this.initializeSearch();
      }
    });

    this.sheetsSubscription = this.sheetsService.sheetsSub.subscribe((resultData) => {
      this.showSheets = !this.showSheets;
    });

    this.bannerCardSubscription = this.bannerCardService.bannerCardSub.subscribe((e) => {
      this.expandBanner = e;
      if (!this.expandBanner) {
        this.resultDisplay.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    this.page = this.router.parseUrl(router.url).root.children['primary'].segments.map(it => it.path).join('/');
    this.isIOS = (/iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
  }

  initializeSearch() {
    // Set default values and re-fetch any data you need.
    // this.loadingScreenService.toggleLoaderOn();
    this.isPharmacy = false;
    this.showCardLoader = true;
    this.showAnywhereCare = false;
    this.showMapToggle = false;
    this.dataNoMap = false;
    this.searchData = [];
    this.upmcData = [];
    this.digitalData = [];
    this.showPromoted = false;
    this.searchDataLength = 0;
    this.activeMarkerLetter = '';
    this.activeMarkerPos = 0;
    this.setMap = false;
    this.inputResultPage = 1;
    this.totalResultPage = 1;
    this.dataResultPage = 1;
    this.arrayResultPage = [];
    this.dataStartPos = 0;
    this.dataEndPos = 0;
    this.clickedSearchCriteria = '';

    this.showLevel1 = true;
    this.showLevels = false;
    this.level1Providers = [];
    this.level1Providers = [];
    this.searchDataLength1 = 0;
    this.searchDataLength2 = 0;

    this.showSheets = false;
    this.expandBanner = false;
    this.notificationContainerService.clearMessages();

    this.paramMap = this.activatedRoute.snapshot.queryParamMap;
    if (this.activatedRoute.snapshot.queryParamMap.keys.length > 0) {
      this.searchObjectService.setSearchObjectQuery(this.paramMap);
      if (this.searchObjectService.isValidSearchObject()) {
        this.searchServices();
      } else {
        this.loadingScreenService.toggleLoaderOff();
      }
    } else {
      this.loadingScreenService.toggleLoaderOff();
    }

    this.isPCPSearch = this.userRulesService.isUserPCP();
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }

    if (this.sheetsSubscription) {
      this.sheetsSubscription.unsubscribe();
    }

    if (this.bannerCardSubscription) {
      this.bannerCardSubscription.unsubscribe();
    }
  }

  searchServices() {
    this.searchErrorMsg = '';
    if (this.searchObjectService.isValidAddress()) {

      if (this.searchObjectService.containsLatLong(this.paramMap.params.address)) {
        this.getServices();
      } else {
        // if address different or latlong doesn't exist geocode the valid address
        this.mapService.getApiKeyObservable().subscribe(() => {
          this.notificationContainerService.clearMessages();
          this.mapService.searchFuzzy(this.searchObjectService.getAddress()).then((res: any) => {
            this.__zone.run(() => {
              const addrs = res.geojson.getFeatures() as GeoJSON.FeatureCollection<GeoJSON.Point>;
              const feats = addrs.features;
              if (feats && feats.length > 0 && feats[0].properties && feats[0].properties!['address']) {
                // const address: any = this.mapService.getFormattedAddress(feats[0]);
                this.getFormattedAddress(feats[0], 'searchService');
              }
            });
          });
        });

      }

    } else {
      this.loadingScreenService.toggleLoaderOff();
    }
  }

  setLatLong(place: any, county: string) {
    const address: any = this.mapService.getLocationObject(place, county);
    if (address && address.geometry && address.geometry.lat && address.geometry.lng) {
      this.searchObjectService.setLatLong(address.geometry.lat, address.geometry.lng);
      if (address.county) {
        this.searchObjectService.setCounty(address.county);
      }
      if (address.state) {
        this.searchObjectService.setState(address.state);
      }
      if (address.postal_code) {
        this.searchObjectService.setZipcode(address.postal_code);
      }
      this.getServices();
    } else {
      this.searchErrorMsg = 'No results match this search';
    /*  if (this.searchObject.mileRadius != '250') {
        this.searchObject.oldMileRadius = this.searchObject.mileRadius;
        this.searchObject.mileRadius = '250';
        this.searchObjectService.setSearchObject(this.searchObject);
        this.searchObjectService.setSearchURL(false, this.searchObject.memberObject.loggedIn, this.searchObject.filters.subProductKey);
      }*/
      this.loadingScreenService.toggleLoaderOff();
      setTimeout(() => {
        this.showCardLoader = false;
      }, 500);
    }
  }

  getFormattedAddress(place: any, from: string) {
    let county;
    const sendAddress = place.properties?.address?.freeformAddress;
    if (sendAddress && !place.properties?.address?.countrySecondarySubdivision) {
      this.mapService.getAddressDetails(sendAddress).subscribe((resp: any) => {
        county = resp.features[0].properties.address.adminDistricts[1].shortName.replace(' Co.', '');
        if (from === 'searchService') {
          this.setLatLong(place, county);
        } else {
          this.setService(place, county);
        }
      });
    } else {
      county = place.properties?.address?.countrySecondarySubdivision;
      if (from === 'searchService') {
        this.setLatLong(place, county);
      } else {
        this.setService(place, county);
      }
    }
  }

  setService(place: any, county: string) {
    const address: any = this.mapService.getLocationObject(place, county);
    if (address) {
      if (address.postal_code) {
        this.searchObjectService.setZipcode(address.postal_code);
      }
      if (address.county || address.state) {
        this.searchObjectService.setCounty(address.county);
        this.searchObjectService.setState(address.state);
        this.searchService.getSearchFilters().subscribe(data => {
          this.notificationContainerService.outOfAreaMessages(data, this.searchObjectService.getSearchObject());
          this.filterNavigationService.serviceFilters(data);
        });
      }
    }
  }

  showSearch() {
    this.showSearchToggle = !this.showSearchToggle;
  }

  onToggleMap(toggleMap: boolean) {
    this.showMapToggle = toggleMap;
    this.expandBanner = false;
    if (toggleMap) {
      this.stickyMap.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      this.resultDisplay.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  onToggleFiltersSelected(bool: boolean) {
    this.filtersSelected = bool;
  }

  onOutputSearchCriteria(obj) {
    if (!this.showSearchToggle) {
      this.showSearchToggle = true;
      setTimeout(() => {
        this.scrollSearchCriteria(obj);
      }, 0);
    } else {
      this.scrollSearchCriteria(obj);
    }
  }

  scrollSearchCriteria(obj) {
    if (obj === 'all') {
      if (this.scrollTopSearch) {
        if (this.isIOS) {
          this.scrollTopSearch.nativeElement.scrollIntoView();
        } else {
          this.scrollTopSearch.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    } else {
      this.clickedSearchCriteria = obj;
    }
    setTimeout(() => {
      this.clickedSearchCriteria = '';
    }, 200);
  }

  showLevelToggle(event) {
    // update practitioners/facilities details to use new resultdata from levels.

    if (event) {
      this.searchData = this.level1Providers;
      this.upmcData = [];
      this.digitalData = [];
      this.totalResultPage = Math.ceil(this.searchDataLength1 / this.showSearchDataDefault);
      this.searchObjectService.setFilterLevel(1);
      this.searchObjectService.updateQueryParams('level', '1');
    } else if (!event) {
      this.searchData = this.level2Providers;
      this.upmcData = [];
      this.digitalData = [];
      this.totalResultPage = Math.ceil(this.searchDataLength2 / this.showSearchDataDefault);
      this.searchObjectService.setFilterLevel(2);
      this.searchObjectService.updateQueryParams('level', '2');
    }

    this.inputResultPage = 1;
    this.dataResultPage = 1;
    this.searchObjectService.setFilterPage(this.dataResultPage);
    this.searchObjectService.updateQueryParams('page', this.dataResultPage);
    this.resetActivePosition();
    this.searchObjectService.updateQueryParams('pos', '');
    this.handleResultsStartEnd();
    this.setArrayResultPage();

    this._setLetterToAddress();
    this.activeMarkerLetter = '';
    this.activeMarkerPos = 0;

    this.showLevel1 = event;

    //this.sendToGAData();
  }

  private _setLetterToAddress() {
    const officeIds = {};
    const _letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '80', '81', '82', '83', '84', '85', '86', '87', '88', '89', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', '100', '101', '102', '103', '104', '105', '106', '107', '108', '109', '110', '111', '112', '113', '114', '115', '116', '117', '118', '119', '120', '121', '122', '123', '124', '125', '126', '127', '128', '129', '130', '131', '132', '133', '134', '135', '136', '137', '138', '139', '140', '141', '142', '143', '144', '145', '146', '147', '148', '149', '150', '151', '152', '153', '154', '155', '156', '157', '158', '159', '160', '161', '162', '163', '164', '165', '166', '167', '168', '169', '170', '171', '172', '173', '174', '175', '176', '177', '178', '179', '180', '181', '182', '183', '184', '185', '186', '187', '188', '189', '190', '191', '192', '193', '194', '195', '196', '197', '198', '199', '200'];
    const startPosition = (this.dataResultPage * this.showSearchDataDefault) - this.showSearchDataDefault;
    const endPosition = this.dataResultPage * this.showSearchDataDefault;


    let index = 0;
    let pos = 0;
    let i = startPosition;
    for (i; i < (endPosition < this.searchData.length ? endPosition : this.searchData.length); i++) {
      if (this.searchData[i].locations.length > 0) {
        pos++;
        const officeId = this.searchData[i].locations[0].officeId;
        if (!officeIds[officeId]) {
          if (index >= _letters.length) {
            index = 0;
          }
          officeIds[officeId] = _letters[index];
          index++;
        }
        this.searchData[i].locations[0].officeAddress['letter'] = officeIds[officeId];
        this.searchData[i]['letter'] = officeIds[officeId];
        this.searchData[i]['index'] = _letters.indexOf(officeIds[officeId]);
        this.searchData[i].position = pos;

        // add to UPMC providers if on page one
        if (this.upmcData.length < this.UPMC_DATA_MAX && startPosition === 0 && this.searchData[i].locations[0].isUpmcOwnedLocation) {
          this.upmcData.push(JSON.parse(JSON.stringify(this.searchData[i])));
        }

        // add to digital providers if on page one
        if (this.digitalData.length < this.DIGITAL_DATA_MAX && startPosition === 0 && this.searchData[i].locations[0].isUpmcOwnedLocation
          && (this.searchData[i].locations[0].offersTeleHealthServices
            || this.searchData[i].locations[0].offersVirtualCareServices)) {
          this.digitalData.push(JSON.parse(JSON.stringify(this.searchData[i])));
        }
      }
    }

    // add to UPMC providers if on different pagees
    this._setAdditionalPromotedSection(i, startPosition, officeIds, index, _letters);
  }

  private _setAdditionalPromotedSection(i, startPosition, officeIds, index, _letters) {
    var upmcDataComplete = false;
    var digitalDataComplete = false;
    if (startPosition === 0 && this.upmcData.length < this.UPMC_DATA_MAX) {
      for (let j = i; j < this.searchData.length; j++) {
        if (this.upmcData.length < this.UPMC_DATA_MAX) {
          if (this.searchData[j].locations.length > 0 && this.searchData[j].locations[0].isUpmcOwnedLocation) {

            const location = this.searchData[j].locations[0];
            const officeId = this.searchData[j].locations[0].officeId;
            if (!officeIds[officeId]) {
              if (index >= _letters.length) {
                index = 0;
              }
              officeIds[officeId] = _letters[index];
              index++;
            }

            location.officeAddress['letter'] = officeIds[officeId];
            this.searchData[j]['letter'] = officeIds[officeId];
            this.searchData[j]['index'] = _letters.indexOf(officeIds[officeId]);

            this.upmcData.push(JSON.parse(JSON.stringify(this.searchData[j])));
          }
        } else {
          upmcDataComplete = true;
        }

        if (this.digitalData.length < this.DIGITAL_DATA_MAX) {
          if (this.searchData[j].locations.length > 0 && this.searchData[j].locations[0].isUpmcOwnedLocation
            && (this.searchData[j].locations[0].offersTeleHealthServices
              || this.searchData[j].locations[0].offersVirtualCareServices)) {

            const location = this.searchData[j].locations[0];
            const officeId = this.searchData[j].locations[0].officeId;
            if (!officeIds[officeId]) {
              if (index >= _letters.length) {
                index = 0;
              }
              officeIds[officeId] = _letters[index];
              index++;
            }

            location.officeAddress['letter'] = officeIds[officeId];
            this.searchData[j]['letter'] = officeIds[officeId];
            this.searchData[j]['index'] = _letters.indexOf(officeIds[officeId]);

            this.digitalData.push(JSON.parse(JSON.stringify(this.searchData[j])));
          }
        } else {
          digitalDataComplete = true;
        }

        if (upmcDataComplete && digitalDataComplete) {
          break;
        }
      }
    }
  }

  returnSortFlag(obj1, obj2) {
    if (obj1['index'] < obj2['index']) { // sort string ascending
      return -1;
    } else if (obj1['index'] > obj2['index']) {
      return 1;
    } else {
      return 0;
    }
  }

  getServices() {
    this.searchErrorMsg = '';
    const _self = this;
    if (this.searchObjectService.checkPeoplePlacesFilter()) {
      this.searchService.getProviders().subscribe(result => {
        if (result.level1Providers.length > 0 || result.level2Providers.length > 0) {
          this.level1Providers = this.sortSpecialties(this.searchResultObjectService.setResults(result.level1Providers.slice(0, _self.maxSearchData)));
          this.level2Providers = this.sortSpecialties(this.searchResultObjectService.setResults(result.level2Providers.slice(0, _self.maxSearchData)));
          this.searchData = this.level1Providers;
          this.searchDataLength1 = this.level1Providers.length;
          this.searchDataLength2 = this.level2Providers.length;
          this.searchDataLength = this.searchDataLength1 + this.searchDataLength2;
          this.searchResultCallback(true, this.searchDataLength, true);
        } else {
          this.searchData = this.sortSpecialties(this.searchResultObjectService.setResults(result.providers.slice(0, _self.maxSearchData)));
          this.searchDataLength = this.searchData.length;
          this.searchResultCallback(true, this.searchDataLength, false);
        }
        if (result.isAnyWhereCareSearch) {
          this.showAnywhereCare = result.isAnyWhereCareSearch;
        }
        if (result.upmcOwnedDisplayIndicator) {
          this.showPromoted = result.upmcOwnedDisplayIndicator;
        }
      }, error => {
        this.searchResultCallback(false, 0, false);
      });
    } else {
      this.searchResultCallback(true, 0, false);
    }

    // county/state out of area service, check if county/state exist
    if (this.searchObjectService.getCounty() || this.searchObjectService.getState()) {
      this.searchService.getSearchFilters().subscribe(data => {
        this.notificationContainerService.outOfAreaMessages(data, this.searchObjectService.getSearchObject());
        this.filterNavigationService.serviceFilters(data);
      });
    } else {

      this.mapService.searchFuzzy([this.searchObjectService.getLong(), this.searchObjectService.getLat()]).then((res: any) => {
        this.__zone.run(() => {
          const addrs = res.geojson.getFeatures() as GeoJSON.FeatureCollection<GeoJSON.Point>;
          const feats = addrs.features;
          if (feats && feats.length > 0 && feats[0].properties && feats[0].properties!['address']) {
            //const address: any = this.mapService.getFormattedAddress(feats[0]);
            this.getFormattedAddress(feats[0], 'getService');
          }
        });
      });
    }
  }

  searchResultCallback(result, resultLength, showlevels) {
    this.searchErrorMsg = '';
    let searchObject = this.searchObjectService.getSearchObject();
    if (searchObject.oldMileRadius) {
      let address = searchObject.zipCode ? searchObject.zipCode : (searchObject.address ? searchObject.address : '')
      this.notificationContainerService.noSearchResultMessage(searchObject.oldMileRadius, address);
    }
    if (!result) {
      this.searchErrorMsg = 'An unexpected error has occurred. Please try your search again later';
    } else if (resultLength === 0) {
      this.searchErrorMsg = 'No results match this search';
      
      if (searchObject.mileRadius != '250') {
        searchObject.oldMileRadius = searchObject.mileRadius;
        searchObject.mileRadius = '250';
        this.searchObjectService.setSearchObject(searchObject);
        this.searchObjectService.setSearchURL(false, searchObject.memberObject.loggedIn, searchObject.filters.subProductKey);
      }
      this.notificationContainerService.showNoResultsMessages(this.searchObjectService.getSearchObject());
      // this.notificationContainerService.showSearchMessage(this.searchObjectService.getSearchObject());
    } else {
      this.showLevels = showlevels;
      if (this.showLevels) {
        if (this.searchDataLength1 === 0 && this.searchDataLength2 > 0) {
          this.showLevelToggle(false);
        } else {
          this.totalResultPage = Math.ceil(this.searchDataLength1 / this.showSearchDataDefault);
        }
      } else {
        this.totalResultPage = Math.ceil(resultLength / this.showSearchDataDefault);
      }

      this.notificationContainerService.showSearchMessage(this.searchObjectService.getSearchObject());

      this.setMap = true;

      this.checkIfPharmacy();
      this.checkIfDigital();
      this.handlePageLevel();
      this.setArrayResultPage();
      this._setLetterToAddress();
      this.handleActivePosition();
      this.handleResultsStartEnd();
      this.loadingScreenService.toggleLoaderOff();
    }

    //this.sendToGAData();

    this.showSearchToggle = true;
    setTimeout(() => {
      this.showCardLoader = false;
    }, 500);
    if (!this.searchObjectService.getFilterPos()) {
      if (this.resultDisplay) {
        setTimeout(() => {
          this.resultDisplay.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
        }, 0);
      }
    }
  }

  sortSpecialties(searchResultObj: SearchResultObject[]) {
    const userInput = this.searchObjectService.getUserInput();
    if (userInput) {
      for (const resultObj of searchResultObj) {
        for (const location of resultObj.locations) {
          const check = location.specialties.some(item => item === userInput);
          const data = location.specialties.filter(item => item !== userInput);
          if (check) {
            data.unshift(userInput);
          }
          location.specialties = data;
        }
      }
    }
    return searchResultObj;
  }

  // isShowNetworkNavigation() {
  //   let searchObject = this.searchObjectService.getSearchObject();
  //   return (!this.isPharmacy || (this.isPharmacy && ['0000010000010001600004','0000010000010001600005'].includes(searchObject?.networkId)));
  // }

  onMarkerClickEvent(letter) {
    this.activeMarkerLetter = letter;
  }

  //#region result page handlers
  ngModelChangeOfPageInput(event) {
    if (!isNaN(Number(event)) && event != null) {
      if (event >= 1 && event <= this.totalResultPage) {
        this.dataResultPage = this.inputResultPage;
        this.handleResultsStartEnd();
        this._setLetterToAddress();
        this.resultDisplay.nativeElement.scrollTop = 0;
        this.searchObjectService.setFilterPage(this.dataResultPage);
        this.searchObjectService.updateQueryParams('page', this.dataResultPage);
        this.resetActivePosition();
        this.searchObjectService.updateQueryParams('pos', '');
        //this.sendToGAData();
      } else {
        this.inputResultPage = this.dataResultPage;
      }
    } else {
      this.inputResultPage = this.dataResultPage;
    }
  }

  changePageInput(i) {
    this.inputResultPage = i;
    this.setPageResults();
  }

  setArrayResultPage() {
    this.arrayResultPage = [];
    for (let i = 1; i <= this.totalResultPage; i++) {
      this.arrayResultPage.push(i);
    }
  }

  handlePageLevel() {
    const level = this.searchObjectService.getFilterLevel();
    const page = this.searchObjectService.getFilterPage();

    if (level && (this.searchDataLength1 > 0 || this.searchDataLength2 > 0)) {
      if (level === '1') {
        this.searchData = this.level1Providers;
        this.totalResultPage = Math.ceil(this.searchDataLength1 / this.showSearchDataDefault);
        this.showLevel1 = true;
      } else if (level === '2') {
        this.searchData = this.level2Providers;
        this.totalResultPage = Math.ceil(this.searchDataLength2 / this.showSearchDataDefault);
        this.showLevel1 = false;
      }
    }

    if (page) {
      if (page > 0 && page <= this.totalResultPage) {
        this.dataResultPage = this.inputResultPage = page;
      }
    }

  }

  handleActivePosition() {
    const pos = this.searchObjectService.getFilterPos();
    if (pos) {
      this.activeMarkerPos = pos;
    }
  }

  resetActivePosition() {
    this.activeMarkerPos = 0;
  }

  handleResultsStartEnd() {
    this.dataStartPos = (this.dataResultPage * this.showSearchDataDefault) - this.showSearchDataDefault;
    this.dataEndPos = ((this.dataResultPage * this.showSearchDataDefault) < this.searchData.length) ? (this.dataResultPage * this.showSearchDataDefault) : this.searchData.length;
  }

  showNextResults() {
    if (this.inputResultPage < this.totalResultPage) {
      this.inputResultPage++;
      this.setPageResults();
    }
  }

  showPrevResults() {
    if (this.inputResultPage > 1) {
      this.inputResultPage--;
      this.setPageResults();
    }
  }

  setPageResults() {
    this.dataResultPage = this.inputResultPage;
    this.handleResultsStartEnd();
    this._setLetterToAddress();
    this.resultDisplay.nativeElement.scrollIntoView({ behavior: 'smooth' });
    this.searchObjectService.setFilterPage(this.dataResultPage);
    this.searchObjectService.updateQueryParams('page', this.dataResultPage);
    this.resetActivePosition();
    this.searchObjectService.updateQueryParams('pos', '');
    //this.sendToGAData();
  }
  //#endregion

  checkIfPharmacy() {
    this.isPharmacy = this.searchObjectService.getCareType() === 'Pharmacy';
  }

  checkIfDigital() {
    this.showDigital = this.searchObjectService.getDigitalMember();
  }

  // sendToGAData() {
  //   //this.GAService.pushResults(this.searchData, this.searchObjectService.getSearchObject(), this.showSearchDataDefault, this.dataResultPage);
  // }

  print() {
    window.print();
  }
}
